var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotAtAllGradient = function SvgNotAtAllGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.987 17.57a2.534 2.534 0 0 1-2.531 2.531H5.544a2.534 2.534 0 0 1-2.531-2.531V7.443a2.535 2.535 0 0 1 2.531-2.532h.886v.38a1.52 1.52 0 0 0 1.52 1.52 1.52 1.52 0 0 0 1.518-1.52v-.38h1.013v.38A1.52 1.52 0 0 0 12 6.811a1.52 1.52 0 0 0 1.519-1.52v-.38h1.013v.38a1.52 1.52 0 0 0 1.519 1.52 1.52 1.52 0 0 0 1.519-1.52v-.38h.886a2.535 2.535 0 0 1 2.531 2.532V17.57ZM7.443 3.519a.507.507 0 0 1 1.013 0v1.772a.507.507 0 0 1-1.013 0V3.52Zm4.05 0a.507.507 0 0 1 1.013 0v1.772a.507.507 0 0 1-1.012 0V3.52Zm4.051 0a.507.507 0 0 1 1.013 0v1.772a.507.507 0 0 1-1.013 0V3.52Zm2.912.38h-.886v-.38A1.52 1.52 0 0 0 16.05 2a1.52 1.52 0 0 0-1.518 1.519v.38h-1.013v-.38A1.52 1.52 0 0 0 12 2a1.52 1.52 0 0 0-1.519 1.519v.38H9.468v-.38A1.52 1.52 0 0 0 7.95 2 1.52 1.52 0 0 0 6.43 3.519v.38h-.886A3.548 3.548 0 0 0 2 7.443V17.57a3.548 3.548 0 0 0 3.544 3.544h12.912A3.548 3.548 0 0 0 22 17.57V7.443a3.548 3.548 0 0 0-3.544-3.544Z",
    fill: "url(#not-at-all-gradient_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "not-at-all-gradient_svg__a",
    x1: 12,
    y1: 2,
    x2: 12,
    y2: 21.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#504CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8482FF"
  })))));
};
export default SvgNotAtAllGradient;